import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { getStore } from "~/app/store/getStore";
import { getSearchEndpointParams } from "~/features/search/api/fetchSearchResults";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const downloadSalesCampaignExcel = () => {
  const apiUrl = occUrl("/salescampaign/download/excel");
  // the salesCampaign download API uses the same params used in the search call
  const searchParams = getSearchEndpointParams(getStore().getState().srp);
  const url = `${apiUrl}?${searchParams.toString()}`;

  return occFetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};

export const downloadSalesCampaignCsv = () => {
  const apiUrl = occUrl("/salescampaign/download/csv");

  const searchParams = getSearchEndpointParams(getStore().getState().srp);
  const url = `${apiUrl}?${searchParams.toString()}`;

  return occFetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
